<template>
  <div class="flex flex-col">
    <div class="bg-grey-lighter border" v-if="mode === 'edit'">
      <button class="px-2 py-3 bg-grey-lighter hover:bg-grey-light relative group" title="Style">
        <i class="fas fa-link fa-fw"></i>
        <i class="fas fa-caret-down"></i>
        <div class="bg-white absolute pin-l pin-t-full border rounded-b whitespace-no-wrap shadow hidden group-hover:block z-10 p-3 text-left">
          <div class="flex flex-col">
            <div class="flex flex-col mb-3">
              <label class="mb-2">Hyperlink</label>
              <input type="url" v-model="content.url" class="border px-3 py-2" placeholder="Enter URL" />
            </div>
          </div>
        </div>
      </button>
    </div>

    <div class="w-full">
      <div class="container mx-auto my-6">
        <div class="flex justify-center">
          <div class="w-full bg-grey-lighter rounded p-6 flex text-center flex-col items-center">
            <h3 class="mb-3 text-lg font-bold" :contenteditable="mode === 'edit'" @blur="content.heading = $event.target.innerText.trim()">
              {{ content.heading }}
            </h3>
            <p class="mb-6" :contenteditable="mode === 'edit'" @blur="content.body = $event.target.innerText.trim()">
              {{ content.body }}
            </p>
            <div class="p-3 bg-grey-light rounded-full" :contenteditable="mode === 'edit'" @blur="content.label = $event.target.innerText.trim()">
              {{ content.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    mode: String
  },
  computed: {
    content: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
